export function stringToRGB(str: string, alpha?: number): string {
  // 短い文字列の場合
  const targetStr = str.repeat(str.length < 2 ? 2: 1);

  let hash = 0;
  for (let i = 0; i < targetStr.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  const r = (hash & 0xff0000) >> 16;
  const g = (hash & 0x00ff00) >>  8;
  const b = (hash & 0x0000ff);

  return `rgb(${r}, ${g}, ${b}, ${alpha ? alpha : 1})`
}
